import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MenuComponent } from 'src/app/system-common/menu/menu.component';
import { MenuService } from 'src/app/system-common/services/menu.service';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { AuthService } from 'src/app/auth.service';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: 'sym-menu-home',
  templateUrl: './menu-home.component.html',
  styleUrls: ['./menu-home.component.css'],
})
export class MenuHomeComponent extends MenuComponent implements OnInit {
  @Input() showMenu;
  constructor(
    public service: MenuService,
    public headerService: HeaderService,
    public authService: AuthService,
    public settingService: SettingService
  ) {
    super(service, headerService, authService, settingService);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  onUserDropDownClick() {
    this.isUserDropdownOpen = !this.isUserDropdownOpen;
  }
}
